// ============================================================================
// JAPANESE TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// 御言葉から抽出された霊的な宝

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "神聖な知恵は抽象的な理論ではなく、私たちの日々の選択の中に現れる具体的な生活です",
    reference: "箴言 3:13-18",
    category: "知恵",
    strongNumbers: {
      "知恵": "H2451", // חָכְמָה (chokmah) = 実践的な知恵
      "悟り": "H8394" // תְּבוּנָה (tebunah) = 識別力
    },
    reflection: "今日、決断において神の知恵をどのように適用できますか？"
  },
  {
    type: "tresor_divine",
    content: "神の愛は私たちの功績に条件付けられたものではなく、神ご自身の本質から流れ出る永遠の賜物です",
    reference: "ローマ 8:38-39",
    category: "愛",
    strongNumbers: {
      "愛": "G26", // ἀγάπη (agape) = 無条件の愛
      "引き離す": "G5563" // χωρίζω (chorizo) = 分離する
    },
    reflection: "キリストにあって示された神の愛から私たちを引き離すものは何もありません"
  },
  {
    type: "lumiere_vie",
    content: "イエスは私たちの道だけでなく、内なる存在をも照らす光です",
    reference: "ヨハネ 8:12",
    category: "アイデンティティ",
    strongNumbers: {
      "光": "G5457", // φῶς (phos) = 光
      "いのち": "G2222" // ζωή (zoe) = 豊かないのち
    },
    reflection: "キリストの光に私の暗闇の領域を照らしてもらうには？"
  },
  {
    type: "force_divine",
    content: "私たちの力は自分自身からではなく、私たちの内に住まわれる方から来ます",
    reference: "エペソ 3:16-17",
    category: "力",
    strongNumbers: {
      "強められる": "G2901", // κραταιόω (krataioo) = 強める
      "力": "G1411" // δύναμις (dynamis) = 神聖な力
    },
    reflection: "弱さの瞬間に神の力を信頼していますか？"
  },
  {
    type: "paix_profonde",
    content: "神の平安は外的な状況に依存せず、私たちの心における神の継続的な臨在に依存します",
    reference: "ピリピ 4:6-7",
    category: "静けさ",
    strongNumbers: {
      "平安": "G1515", // εἰρήνη (eirene) = 完全な平安
      "守る": "G5432" // φρουρέω (phroureo) = 要塞のように守る
    },
    reflection: "すべての理解を超えた神の平安をどのように培いますか？"
  },
  {
    type: "esperance_vivante",
    content: "私たちの希望は不確かな願いではなく、神の忠実な約束に基づいた堅固な錨です",
    reference: "ヘブル 6:19",
    category: "希望",
    strongNumbers: {
      "希望": "G1680", // ἐλπίς (elpis) = 確信に満ちた希望
      "錨": "G45" // ἄγκυρα (ankyra) = 魂の錨
    },
    reflection: "今日、どの神の約束に希望を錨泊させますか？"
  },
  {
    type: "transformation",
    content: "霊的変容は継続的なプロセスであり、私たちは毎日キリストの御姿により似た者となっていきます",
    reference: "2コリント 3:18",
    category: "成長",
    strongNumbers: {
      "変えられ": "G3339", // μεταμορφόω (metamorphoo) = 完全に変容させる
      "栄光": "G1391" // δόξα (doxa) = 神聖な栄光
    },
    reflection: "今日、私の人生のどの領域が変容を必要としていますか？"
  }
];

export default bibleTreasures;
